import find from 'lodash/find';
import { userRoles } from 'config/constants';

// Inspect access for the current user on the current stack (il-inspect-landing-page).
// on: the stack has showInspect, or the user holds the useInspect role, or the settings fetch failed (fail open).
// off: stack settings loaded without showInspect AND roles loaded without the role.
// pending: anything not loaded yet. viaUserOnly: the role alone grants it on a stack that is loaded and off.
// Roles count as loaded once the user is (uuid set): a user document with roles null or absent has no roles.
// The current account's settings, once fetched, win over its accountsList entry (the entry can be stale).
// A failed fetch followed by a late success may show the module briefly, then the landing page (accepted).
export var INSPECT_ACCESS = {
  PENDING: 'pending',
  ON: 'on',
  OFF: 'off',
};

// The api's rule (its Decision 6): JSON true, or the string "true" ignoring case. 1, "yes", "false", null and every
// other value are off. Not JS truthiness: the dashboard and the api must agree.
export function isShowInspectOn(value) {
  return value === true || (typeof value === 'string' && value.toLowerCase() === 'true');
}

function access(status, viaUserOnly) {
  return { status: status, viaUserOnly: !!viaUserOnly };
}

export function getInspectAccess(state) {
  var accounts = (state && state.accounts) || {};
  var current = accounts.currentAccount;
  var user = (state && state.currentUser) || {};
  var roles = Array.isArray(user.roles) ? user.roles : [];
  var rolesLoaded = Array.isArray(user.roles) || !!user.uuid;
  var userOn = rolesLoaded && roles.indexOf(userRoles.USE_INSPECT) !== -1;

  if (!current || !current.uuid) {
    return access(userOn ? INSPECT_ACCESS.ON : INSPECT_ACCESS.PENDING, false);
  }

  var entry = Array.isArray(accounts.accountsList) ? find(accounts.accountsList, { uuid: current.uuid }) : null;
  var entrySettings = entry ? entry.settings : undefined;
  var currentSettings = current.settings;
  var settings = currentSettings !== undefined ? currentSettings : entrySettings;
  var loaded = settings !== undefined;
  var stackOn = isShowInspectOn(settings && settings.showInspect);

  if (stackOn) return access(INSPECT_ACCESS.ON, false);
  if (userOn) return access(INSPECT_ACCESS.ON, loaded);
  if (!loaded) {
    var failed = accounts.settingsFetchFailed || {};
    return access(failed[current.uuid] ? INSPECT_ACCESS.ON : INSPECT_ACCESS.PENDING, false);
  }
  if (!rolesLoaded) return access(INSPECT_ACCESS.PENDING, false);
  return access(INSPECT_ACCESS.OFF, false);
}

// True when a route table entry is an Inspect route and access is evaluated and off.
export function isInspectGatedOff(route, inspectAccess) {
  return !!(
    route &&
    route.requiresInspect &&
    inspectAccess &&
    inspectAccess.status === INSPECT_ACCESS.OFF
  );
}
